import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { validator } from "LIB/validate-this";
import * as actions from "MODULES/inventories/actions";
import * as rules from "LIB/validation/rules";
import {
  form,
  Form as AppForm,
  FileInput,
  FormTypes
} from "MODULES/shared/components/Forms";

export function ScrapReportReceivedForm(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name="scrap_report"
          component={FileInput}
          label="Upload Attachment"
        />
      </AppForm.Body>
    </AppForm>
  );
}

ScrapReportReceivedForm.propTypes = FormTypes.modalForm;

function validate(values) {
  return validator(values, f => {
    f.validate("scrap_report").satisfies(rules.required);
  });
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.upload(data))
}))(
  form({
    form: "scrapReportReceivedForm",
    validate
  })(ScrapReportReceivedForm)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/ScrapReportReceived/ScrapReportReceivedForm.jsx